module.exports = __webpack_public_path__ + "static/media/010-Begruessen_ID_9.d8625933.mp3";